<template>
  <div class="container">
    <PublicHeader :totalName="$t('share').Invitefriends" />
    <div class="share_popup">
      <div class="cord_box">
        <qrcode-vue :value="link" :size="size" level="H" class="qrcode"></qrcode-vue>
      </div>
      <div class="cord_txt">{{ $t('share').ReferralCode }}</div>
      <div class="cord_link">{{ userInfo.invitationCode }}</div>
    </div>
    <!-- 按钮 -->
    <van-button block @click="onCopy(link)">{{ $t('public').copyTxt }}</van-button>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import userApi from '@/api/user'
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader,
    QrcodeVue
  },
  data() {
    return {
      userInfo: {},
      link: '5556326546',
      size: 210
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getMemberInfo()
  },
  methods: {
    async getMemberInfo() {
      const aBase = await userApi.getMemberInfo()
      this.userInfo = aBase.user
      const res = await systemApi.getConfig()
      this.link = res.systemSetting.shareUrl + '/#/register?code=' + this.userInfo.invitationCode
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 65px 15px 0 15px;
  background: var(--background_color);

  .share_popup {
    margin: 0 30px;
    border-radius: 15px;
    border: 2px solid var(--info_color);
    padding: 15px;

    .cord_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px;
    }

    .cord_txt {
      font-size: 15px;
      color: var(--ntext_color);
      text-align: center;
    }

    .cord_link {
      margin-top: 10px;
      padding: 15px;
      font-size: 17px;
      font-weight: bold;
      color: var(--primary_color);
      text-align: center;
      border-radius: 15px;
    }
  }

  .van-button {
    margin-top: 50px;
    background: var(--primary_color);
    height: 40px;
    border-radius: 20px;
    border: 0;
    font-size: 15px;
    color: #fff;
  }
}
</style>
